import { render } from "./PrivacyPolicyContent.vue?vue&type=template&id=771129fe"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp64\\www\\safest\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__